import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: unset;\n\n  > div > div > section {\n    min-width: 400px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import React, { useEffect } from "react";
import styled from "styled-components";
import PurchaseSection from "@/components/Package/PurchaseSection";
import { usePurchaseStore } from "@/components/Package/PurchaseSection/purchaseStore";
import Modal from "@/components/modal/Modal";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { Drawer } from "antd";
import useHandoutProductStore from "../../../store/relatedProduct";
export const HandoutPassSectionModal = (param)=>{
    let {} = param;
    const { isLoggedIn , user: { hasUsableFreepass  }  } = useAuthStore();
    const showCouponModal = usePurchaseStore((state)=>state.showCouponModal);
    const { isMobile  } = useWindowDimensions();
    const { currentProduct , isOpenPassSectionModal , closePassSectionModal , freeTrialData , isFreeTrialLoading  } = useHandoutProductStore((state)=>state);
    useEffect(()=>{
        if (isMobile) return;
        if (isOpenPassSectionModal && showCouponModal) {
            closePassSectionModal();
        }
    }, [
        isMobile,
        isOpenPassSectionModal,
        showCouponModal
    ]);
    //태블릿은 모달
    //모바일은 바텀시트
    if (!isMobile) return /*#__PURE__*/ _jsx(PassSectionModalLayout, {
        open: isOpenPassSectionModal,
        onClose: closePassSectionModal,
        width: null,
        // PurchaseModals, PassMenuList보다 낮은 z-index를 가져야 함.
        depth: 1007,
        children: /*#__PURE__*/ _jsx(PurchaseSection, {
            sx: {
                minWidth: "400px"
            },
            product: currentProduct,
            hasUsableFreepass: hasUsableFreepass,
            isLoggedIn: isLoggedIn,
            freeTrialData: freeTrialData !== null && freeTrialData !== void 0 ? freeTrialData : undefined,
            isFreeTrialLoading: isFreeTrialLoading,
            isInModal: true
        })
    });
    return /*#__PURE__*/ _jsx(Drawer, {
        headerStyle: {
            display: "none"
        },
        bodyStyle: {
            padding: 0
        },
        style: {
            borderRadius: "12px 12px 0 0"
        },
        contentWrapperStyle: {
            borderRadius: "12px 12px 0 0"
        },
        push: true,
        zIndex: 1007,
        onClose: closePassSectionModal,
        open: isOpenPassSectionModal,
        height: "unset",
        placement: "bottom",
        children: /*#__PURE__*/ _jsx(PurchaseSection, {
            product: currentProduct,
            hasUsableFreepass: hasUsableFreepass,
            isLoggedIn: isLoggedIn,
            fullWidth: true,
            freeTrialData: freeTrialData !== null && freeTrialData !== void 0 ? freeTrialData : undefined,
            isFreeTrialLoading: isFreeTrialLoading,
            isInModal: true
        })
    });
};
const PassSectionModalLayout = styled(Modal).withConfig({
    componentId: "sc-dd3bad29-0"
})(_templateObject());
export const thumbWidth = 56;
